import type { NamedIconComponentType } from '../../components'
import * as NamedIcons from '../../components/icon/named-icons'

export enum IconNames {
	addressBook = 'addressBook',
	alarmClock = 'alarmClock',
	allergy = 'allergy',
	arrowBackward = 'arrowBackward',
	arrowDown = 'arrowDown',
	arrowDowntrend = 'arrowDowntrend',
	arrowForward = 'arrowForward',
	arrowTrack = 'arrowTrack',
	arrowUp = 'arrowUp',
	arrowUptrend = 'arrowUptrend',
	arrowUptrendSquare = 'arrowUptrendSquare',
	arrowsBackwardForward = 'arrowsBackwardForward',
	arrowsCollapse = 'arrowsCollapse',
	arrowsExpand = 'arrowsExpand',
	arrowsUpDown = 'arrowsUpDown',
	backspace = 'backspace',
	badge = 'badge',
	badgeEqual = 'badgeEqual',
	bag = 'bag',
	bagCheck = 'bagCheck',
	bagCross = 'bagCross',
	bagGlovo = 'bagGlovo',
	bagHappy = 'bagHappy',
	bagInfo = 'bagInfo',
	bags = 'bags',
	bars = 'bars',
	batteryCharging = 'batteryCharging',
	batteryFull = 'batteryFull',
	batteryHalf = 'batteryHalf',
	batteryLow = 'batteryLow',
	batterySlash = 'batterySlash',
	bell = 'bell',
	bench = 'bench',
	bicycle = 'bicycle',
	binoculars = 'binoculars',
	bookmark = 'bookmark',
	bug = 'bug',
	buildings = 'buildings',
	burgerSize = 'burgerSize',
	cake = 'cake',
	calendar = 'calendar',
	camera = 'camera',
	car = 'car',
	card = 'card',
	cardArrowDown = 'cardArrowDown',
	cardArrowUp = 'cardArrowUp',
	cardGlovo = 'cardGlovo',
	cardMagnifyingGlass = 'cardMagnifyingGlass',
	cardPin = 'cardPin',
	cards = 'cards',
	caretBackward = 'caretBackward',
	caretDown = 'caretDown',
	caretForward = 'caretForward',
	caretUp = 'caretUp',
	carrot = 'carrot',
	cash = 'cash',
	cashArrowDown = 'cashArrowDown',
	cashArrowUp = 'cashArrowUp',
	chartBars = 'chartBars',
	chartBarsCircle = 'chartBarsCircle',
	chartPie = 'chartPie',
	chat = 'chat',
	chatBubbles = 'chatBubbles',
	chatBubblesQuestion = 'chatBubblesQuestion',
	chatCross = 'chatCross',
	chatPhone = 'chatPhone',
	chatQuestion = 'chatQuestion',
	check = 'check',
	checkCircle = 'checkCircle',
	chevronBackward = 'chevronBackward',
	chevronDown = 'chevronDown',
	chevronForward = 'chevronForward',
	chevronForwardDouble = 'chevronForwardDouble',
	chevronUp = 'chevronUp',
	circle = 'circle',
	circlesConcentric = 'circlesConcentric',
	clip = 'clip',
	clock = 'clock',
	clockBack = 'clockBack',
	cloudRain = 'cloudRain',
	cloudSnow = 'cloudSnow',
	cog = 'cog',
	coinArrowUp = 'coinArrowUp',
	collapseVertical = 'collapseVertical',
	companyBuilding = 'companyBuilding',
	compass = 'compass',
	copy = 'copy',
	cross = 'cross',
	crossCircle = 'crossCircle',
	crown = 'crown',
	cutlery = 'cutlery',
	cutlerySlash = 'cutlerySlash',
	deskBell = 'deskBell',
	diamond = 'diamond',
	directions = 'directions',
	discount = 'discount',
	download = 'download',
	drop = 'drop',
	edit = 'edit',
	eggBroken = 'eggBroken',
	eggQuestion = 'eggQuestion',
	ellipsisHorizontal = 'ellipsisHorizontal',
	ellipsisVertical = 'ellipsisVertical',
	enter = 'enter',
	envelope = 'envelope',
	exclamationCircle = 'exclamationCircle',
	exclamationTriangle = 'exclamationTriangle',
	exit = 'exit',
	expandVertical = 'expandVertical',
	externalLink = 'externalLink',
	eyeClosed = 'eyeClosed',
	eyeOpen = 'eyeOpen',
	familyAid = 'familyAid',
	file = 'file',
	fileMagnifyingGlass = 'fileMagnifyingGlass',
	filePencil = 'filePencil',
	filter = 'filter',
	fire = 'fire',
	flag = 'flag',
	flagCheckered = 'flagCheckered',
	flagTriangle = 'flagTriangle',
	flashlight = 'flashlight',
	flashlightSlash = 'flashlightSlash',
	forbidden = 'forbidden',
	ghost = 'ghost',
	gift = 'gift',
	globe = 'globe',
	grid = 'grid',
	handArrowSwipe = 'handArrowSwipe',
	handCross = 'handCross',
	handDigits = 'handDigits',
	handHeart = 'handHeart',
	hash = 'hash',
	headset = 'headset',
	heart = 'heart',
	house = 'house',
	hurricane = 'hurricane',
	image = 'image',
	infoCircle = 'infoCircle',
	languages = 'languages',
	layers = 'layers',
	leaf = 'leaf',
	lightbulb = 'lightbulb',
	lightning = 'lightning',
	list = 'list',
	locationArrow = 'locationArrow',
	locationGps = 'locationGps',
	locationMarker = 'locationMarker',
	locationPin = 'locationPin',
	locationZone = 'locationZone',
	locationZoneSlash = 'locationZoneSlash',
	lockArrowBack = 'lockArrowBack',
	lockClosed = 'lockClosed',
	lockOpen = 'lockOpen',
	logoGlovo = 'logoGlovo',
	logoPrime = 'logoPrime',
	loop = 'loop',
	magnifyingGlass = 'magnifyingGlass',
	map = 'map',
	medal = 'medal',
	megaphone = 'megaphone',
	menu = 'menu',
	milkCarton = 'milkCarton',
	milkCartonSlash = 'milkCartonSlash',
	minus = 'minus',
	mobile = 'mobile',
	mobileAlert = 'mobileAlert',
	mobileCard = 'mobileCard',
	mobileCash = 'mobileCash',
	monitor = 'monitor',
	moon = 'moon',
	motorcycle = 'motorcycle',
	over18Circle = 'over18Circle',
	over21Circle = 'over21Circle',
	package = 'package',
	partyPopper = 'partyPopper',
	paste = 'paste',
	pencil = 'pencil',
	people = 'people',
	person = 'person',
	personFrame = 'personFrame',
	personPlus = 'personPlus',
	personRider = 'personRider',
	personTongue = 'personTongue',
	personWalking = 'personWalking',
	phone = 'phone',
	phoneSlash = 'phoneSlash',
	phoneSos = 'phoneSos',
	plus = 'plus',
	plusCircle = 'plusCircle',
	qrCode = 'qrCode',
	questionCircle = 'questionCircle',
	receipt = 'receipt',
	redo = 'redo',
	rocket = 'rocket',
	scales = 'scales',
	schoolBag = 'schoolBag',
	server = 'server',
	shareAndroid = 'shareAndroid',
	shareIos = 'shareIos',
	shield = 'shield',
	shop = 'shop',
	shoppingCart = 'shoppingCart',
	signature = 'signature',
	sliders = 'sliders',
	snail = 'snail',
	snowflake = 'snowflake',
	sound = 'sound',
	soundSlash = 'soundSlash',
	sparkle = 'sparkle',
	star = 'star',
	stopWatch = 'stopWatch',
	storeSign = 'storeSign',
	storeSignCheck = 'storeSignCheck',
	storeSignCross = 'storeSignCross',
	sun = 'sun',
	tachometer = 'tachometer',
	tag = 'tag',
	tagDiscount = 'tagDiscount',
	text = 'text',
	thermometerHot = 'thermometerHot',
	thermometerLow = 'thermometerLow',
	thermometerMedium = 'thermometerMedium',
	thermometerZero = 'thermometerZero',
	thumbDown = 'thumbDown',
	thumbUp = 'thumbUp',
	timeline = 'timeline',
	timelineClock = 'timelineClock',
	trash = 'trash',
	undo = 'undo',
	undoCash = 'undoCash',
	undoCross = 'undoCross',
	upload = 'upload',
	wallet = 'wallet',
	walletCoins = 'walletCoins',
	wand = 'wand',
	wheat = 'wheat',
	wheatSlash = 'wheatSlash',
	wifi = 'wifi',
	wifiSlash = 'wifiSlash',
}

export type IconNamesType = `${IconNames}`

export const AsyncIconComponentsMap: Record<IconNames, () => Promise<{ default: NamedIconComponentType }>> = {
    
	addressBook: () =>
        import('../../components/icon/named-icons/AddressBookIcon').then((module) => ({
            default: module.AddressBookIcon,
        })),
	alarmClock: () =>
        import('../../components/icon/named-icons/AlarmClockIcon').then((module) => ({
            default: module.AlarmClockIcon,
        })),
	allergy: () =>
        import('../../components/icon/named-icons/AllergyIcon').then((module) => ({
            default: module.AllergyIcon,
        })),
	arrowBackward: () =>
        import('../../components/icon/named-icons/ArrowBackwardIcon').then((module) => ({
            default: module.ArrowBackwardIcon,
        })),
	arrowDown: () =>
        import('../../components/icon/named-icons/ArrowDownIcon').then((module) => ({
            default: module.ArrowDownIcon,
        })),
	arrowDowntrend: () =>
        import('../../components/icon/named-icons/ArrowDowntrendIcon').then((module) => ({
            default: module.ArrowDowntrendIcon,
        })),
	arrowForward: () =>
        import('../../components/icon/named-icons/ArrowForwardIcon').then((module) => ({
            default: module.ArrowForwardIcon,
        })),
	arrowTrack: () =>
        import('../../components/icon/named-icons/ArrowTrackIcon').then((module) => ({
            default: module.ArrowTrackIcon,
        })),
	arrowUp: () =>
        import('../../components/icon/named-icons/ArrowUpIcon').then((module) => ({
            default: module.ArrowUpIcon,
        })),
	arrowUptrend: () =>
        import('../../components/icon/named-icons/ArrowUptrendIcon').then((module) => ({
            default: module.ArrowUptrendIcon,
        })),
	arrowUptrendSquare: () =>
        import('../../components/icon/named-icons/ArrowUptrendSquareIcon').then((module) => ({
            default: module.ArrowUptrendSquareIcon,
        })),
	arrowsBackwardForward: () =>
        import('../../components/icon/named-icons/ArrowsBackwardForwardIcon').then((module) => ({
            default: module.ArrowsBackwardForwardIcon,
        })),
	arrowsCollapse: () =>
        import('../../components/icon/named-icons/ArrowsCollapseIcon').then((module) => ({
            default: module.ArrowsCollapseIcon,
        })),
	arrowsExpand: () =>
        import('../../components/icon/named-icons/ArrowsExpandIcon').then((module) => ({
            default: module.ArrowsExpandIcon,
        })),
	arrowsUpDown: () =>
        import('../../components/icon/named-icons/ArrowsUpDownIcon').then((module) => ({
            default: module.ArrowsUpDownIcon,
        })),
	backspace: () =>
        import('../../components/icon/named-icons/BackspaceIcon').then((module) => ({
            default: module.BackspaceIcon,
        })),
	badge: () =>
        import('../../components/icon/named-icons/BadgeIcon').then((module) => ({
            default: module.BadgeIcon,
        })),
	badgeEqual: () =>
        import('../../components/icon/named-icons/BadgeEqualIcon').then((module) => ({
            default: module.BadgeEqualIcon,
        })),
	bag: () =>
        import('../../components/icon/named-icons/BagIcon').then((module) => ({
            default: module.BagIcon,
        })),
	bagCheck: () =>
        import('../../components/icon/named-icons/BagCheckIcon').then((module) => ({
            default: module.BagCheckIcon,
        })),
	bagCross: () =>
        import('../../components/icon/named-icons/BagCrossIcon').then((module) => ({
            default: module.BagCrossIcon,
        })),
	bagGlovo: () =>
        import('../../components/icon/named-icons/BagGlovoIcon').then((module) => ({
            default: module.BagGlovoIcon,
        })),
	bagHappy: () =>
        import('../../components/icon/named-icons/BagHappyIcon').then((module) => ({
            default: module.BagHappyIcon,
        })),
	bagInfo: () =>
        import('../../components/icon/named-icons/BagInfoIcon').then((module) => ({
            default: module.BagInfoIcon,
        })),
	bags: () =>
        import('../../components/icon/named-icons/BagsIcon').then((module) => ({
            default: module.BagsIcon,
        })),
	bars: () =>
        import('../../components/icon/named-icons/BarsIcon').then((module) => ({
            default: module.BarsIcon,
        })),
	batteryCharging: () =>
        import('../../components/icon/named-icons/BatteryChargingIcon').then((module) => ({
            default: module.BatteryChargingIcon,
        })),
	batteryFull: () =>
        import('../../components/icon/named-icons/BatteryFullIcon').then((module) => ({
            default: module.BatteryFullIcon,
        })),
	batteryHalf: () =>
        import('../../components/icon/named-icons/BatteryHalfIcon').then((module) => ({
            default: module.BatteryHalfIcon,
        })),
	batteryLow: () =>
        import('../../components/icon/named-icons/BatteryLowIcon').then((module) => ({
            default: module.BatteryLowIcon,
        })),
	batterySlash: () =>
        import('../../components/icon/named-icons/BatterySlashIcon').then((module) => ({
            default: module.BatterySlashIcon,
        })),
	bell: () =>
        import('../../components/icon/named-icons/BellIcon').then((module) => ({
            default: module.BellIcon,
        })),
	bench: () =>
        import('../../components/icon/named-icons/BenchIcon').then((module) => ({
            default: module.BenchIcon,
        })),
	bicycle: () =>
        import('../../components/icon/named-icons/BicycleIcon').then((module) => ({
            default: module.BicycleIcon,
        })),
	binoculars: () =>
        import('../../components/icon/named-icons/BinocularsIcon').then((module) => ({
            default: module.BinocularsIcon,
        })),
	bookmark: () =>
        import('../../components/icon/named-icons/BookmarkIcon').then((module) => ({
            default: module.BookmarkIcon,
        })),
	bug: () =>
        import('../../components/icon/named-icons/BugIcon').then((module) => ({
            default: module.BugIcon,
        })),
	buildings: () =>
        import('../../components/icon/named-icons/BuildingsIcon').then((module) => ({
            default: module.BuildingsIcon,
        })),
	burgerSize: () =>
        import('../../components/icon/named-icons/BurgerSizeIcon').then((module) => ({
            default: module.BurgerSizeIcon,
        })),
	cake: () =>
        import('../../components/icon/named-icons/CakeIcon').then((module) => ({
            default: module.CakeIcon,
        })),
	calendar: () =>
        import('../../components/icon/named-icons/CalendarIcon').then((module) => ({
            default: module.CalendarIcon,
        })),
	camera: () =>
        import('../../components/icon/named-icons/CameraIcon').then((module) => ({
            default: module.CameraIcon,
        })),
	car: () =>
        import('../../components/icon/named-icons/CarIcon').then((module) => ({
            default: module.CarIcon,
        })),
	card: () =>
        import('../../components/icon/named-icons/CardIcon').then((module) => ({
            default: module.CardIcon,
        })),
	cardArrowDown: () =>
        import('../../components/icon/named-icons/CardArrowDownIcon').then((module) => ({
            default: module.CardArrowDownIcon,
        })),
	cardArrowUp: () =>
        import('../../components/icon/named-icons/CardArrowUpIcon').then((module) => ({
            default: module.CardArrowUpIcon,
        })),
	cardGlovo: () =>
        import('../../components/icon/named-icons/CardGlovoIcon').then((module) => ({
            default: module.CardGlovoIcon,
        })),
	cardMagnifyingGlass: () =>
        import('../../components/icon/named-icons/CardMagnifyingGlassIcon').then((module) => ({
            default: module.CardMagnifyingGlassIcon,
        })),
	cardPin: () =>
        import('../../components/icon/named-icons/CardPinIcon').then((module) => ({
            default: module.CardPinIcon,
        })),
	cards: () =>
        import('../../components/icon/named-icons/CardsIcon').then((module) => ({
            default: module.CardsIcon,
        })),
	caretBackward: () =>
        import('../../components/icon/named-icons/CaretBackwardIcon').then((module) => ({
            default: module.CaretBackwardIcon,
        })),
	caretDown: () =>
        import('../../components/icon/named-icons/CaretDownIcon').then((module) => ({
            default: module.CaretDownIcon,
        })),
	caretForward: () =>
        import('../../components/icon/named-icons/CaretForwardIcon').then((module) => ({
            default: module.CaretForwardIcon,
        })),
	caretUp: () =>
        import('../../components/icon/named-icons/CaretUpIcon').then((module) => ({
            default: module.CaretUpIcon,
        })),
	carrot: () =>
        import('../../components/icon/named-icons/CarrotIcon').then((module) => ({
            default: module.CarrotIcon,
        })),
	cash: () =>
        import('../../components/icon/named-icons/CashIcon').then((module) => ({
            default: module.CashIcon,
        })),
	cashArrowDown: () =>
        import('../../components/icon/named-icons/CashArrowDownIcon').then((module) => ({
            default: module.CashArrowDownIcon,
        })),
	cashArrowUp: () =>
        import('../../components/icon/named-icons/CashArrowUpIcon').then((module) => ({
            default: module.CashArrowUpIcon,
        })),
	chartBars: () =>
        import('../../components/icon/named-icons/ChartBarsIcon').then((module) => ({
            default: module.ChartBarsIcon,
        })),
	chartBarsCircle: () =>
        import('../../components/icon/named-icons/ChartBarsCircleIcon').then((module) => ({
            default: module.ChartBarsCircleIcon,
        })),
	chartPie: () =>
        import('../../components/icon/named-icons/ChartPieIcon').then((module) => ({
            default: module.ChartPieIcon,
        })),
	chat: () =>
        import('../../components/icon/named-icons/ChatIcon').then((module) => ({
            default: module.ChatIcon,
        })),
	chatBubbles: () =>
        import('../../components/icon/named-icons/ChatBubblesIcon').then((module) => ({
            default: module.ChatBubblesIcon,
        })),
	chatBubblesQuestion: () =>
        import('../../components/icon/named-icons/ChatBubblesQuestionIcon').then((module) => ({
            default: module.ChatBubblesQuestionIcon,
        })),
	chatCross: () =>
        import('../../components/icon/named-icons/ChatCrossIcon').then((module) => ({
            default: module.ChatCrossIcon,
        })),
	chatPhone: () =>
        import('../../components/icon/named-icons/ChatPhoneIcon').then((module) => ({
            default: module.ChatPhoneIcon,
        })),
	chatQuestion: () =>
        import('../../components/icon/named-icons/ChatQuestionIcon').then((module) => ({
            default: module.ChatQuestionIcon,
        })),
	check: () =>
        import('../../components/icon/named-icons/CheckIcon').then((module) => ({
            default: module.CheckIcon,
        })),
	checkCircle: () =>
        import('../../components/icon/named-icons/CheckCircleIcon').then((module) => ({
            default: module.CheckCircleIcon,
        })),
	chevronBackward: () =>
        import('../../components/icon/named-icons/ChevronBackwardIcon').then((module) => ({
            default: module.ChevronBackwardIcon,
        })),
	chevronDown: () =>
        import('../../components/icon/named-icons/ChevronDownIcon').then((module) => ({
            default: module.ChevronDownIcon,
        })),
	chevronForward: () =>
        import('../../components/icon/named-icons/ChevronForwardIcon').then((module) => ({
            default: module.ChevronForwardIcon,
        })),
	chevronForwardDouble: () =>
        import('../../components/icon/named-icons/ChevronForwardDoubleIcon').then((module) => ({
            default: module.ChevronForwardDoubleIcon,
        })),
	chevronUp: () =>
        import('../../components/icon/named-icons/ChevronUpIcon').then((module) => ({
            default: module.ChevronUpIcon,
        })),
	circle: () =>
        import('../../components/icon/named-icons/CircleIcon').then((module) => ({
            default: module.CircleIcon,
        })),
	circlesConcentric: () =>
        import('../../components/icon/named-icons/CirclesConcentricIcon').then((module) => ({
            default: module.CirclesConcentricIcon,
        })),
	clip: () =>
        import('../../components/icon/named-icons/ClipIcon').then((module) => ({
            default: module.ClipIcon,
        })),
	clock: () =>
        import('../../components/icon/named-icons/ClockIcon').then((module) => ({
            default: module.ClockIcon,
        })),
	clockBack: () =>
        import('../../components/icon/named-icons/ClockBackIcon').then((module) => ({
            default: module.ClockBackIcon,
        })),
	cloudRain: () =>
        import('../../components/icon/named-icons/CloudRainIcon').then((module) => ({
            default: module.CloudRainIcon,
        })),
	cloudSnow: () =>
        import('../../components/icon/named-icons/CloudSnowIcon').then((module) => ({
            default: module.CloudSnowIcon,
        })),
	cog: () =>
        import('../../components/icon/named-icons/CogIcon').then((module) => ({
            default: module.CogIcon,
        })),
	coinArrowUp: () =>
        import('../../components/icon/named-icons/CoinArrowUpIcon').then((module) => ({
            default: module.CoinArrowUpIcon,
        })),
	collapseVertical: () =>
        import('../../components/icon/named-icons/CollapseVerticalIcon').then((module) => ({
            default: module.CollapseVerticalIcon,
        })),
	companyBuilding: () =>
        import('../../components/icon/named-icons/CompanyBuildingIcon').then((module) => ({
            default: module.CompanyBuildingIcon,
        })),
	compass: () =>
        import('../../components/icon/named-icons/CompassIcon').then((module) => ({
            default: module.CompassIcon,
        })),
	copy: () =>
        import('../../components/icon/named-icons/CopyIcon').then((module) => ({
            default: module.CopyIcon,
        })),
	cross: () =>
        import('../../components/icon/named-icons/CrossIcon').then((module) => ({
            default: module.CrossIcon,
        })),
	crossCircle: () =>
        import('../../components/icon/named-icons/CrossCircleIcon').then((module) => ({
            default: module.CrossCircleIcon,
        })),
	crown: () =>
        import('../../components/icon/named-icons/CrownIcon').then((module) => ({
            default: module.CrownIcon,
        })),
	cutlery: () =>
        import('../../components/icon/named-icons/CutleryIcon').then((module) => ({
            default: module.CutleryIcon,
        })),
	cutlerySlash: () =>
        import('../../components/icon/named-icons/CutlerySlashIcon').then((module) => ({
            default: module.CutlerySlashIcon,
        })),
	deskBell: () =>
        import('../../components/icon/named-icons/DeskBellIcon').then((module) => ({
            default: module.DeskBellIcon,
        })),
	diamond: () =>
        import('../../components/icon/named-icons/DiamondIcon').then((module) => ({
            default: module.DiamondIcon,
        })),
	directions: () =>
        import('../../components/icon/named-icons/DirectionsIcon').then((module) => ({
            default: module.DirectionsIcon,
        })),
	discount: () =>
        import('../../components/icon/named-icons/DiscountIcon').then((module) => ({
            default: module.DiscountIcon,
        })),
	download: () =>
        import('../../components/icon/named-icons/DownloadIcon').then((module) => ({
            default: module.DownloadIcon,
        })),
	drop: () =>
        import('../../components/icon/named-icons/DropIcon').then((module) => ({
            default: module.DropIcon,
        })),
	edit: () =>
        import('../../components/icon/named-icons/EditIcon').then((module) => ({
            default: module.EditIcon,
        })),
	eggBroken: () =>
        import('../../components/icon/named-icons/EggBrokenIcon').then((module) => ({
            default: module.EggBrokenIcon,
        })),
	eggQuestion: () =>
        import('../../components/icon/named-icons/EggQuestionIcon').then((module) => ({
            default: module.EggQuestionIcon,
        })),
	ellipsisHorizontal: () =>
        import('../../components/icon/named-icons/EllipsisHorizontalIcon').then((module) => ({
            default: module.EllipsisHorizontalIcon,
        })),
	ellipsisVertical: () =>
        import('../../components/icon/named-icons/EllipsisVerticalIcon').then((module) => ({
            default: module.EllipsisVerticalIcon,
        })),
	enter: () =>
        import('../../components/icon/named-icons/EnterIcon').then((module) => ({
            default: module.EnterIcon,
        })),
	envelope: () =>
        import('../../components/icon/named-icons/EnvelopeIcon').then((module) => ({
            default: module.EnvelopeIcon,
        })),
	exclamationCircle: () =>
        import('../../components/icon/named-icons/ExclamationCircleIcon').then((module) => ({
            default: module.ExclamationCircleIcon,
        })),
	exclamationTriangle: () =>
        import('../../components/icon/named-icons/ExclamationTriangleIcon').then((module) => ({
            default: module.ExclamationTriangleIcon,
        })),
	exit: () =>
        import('../../components/icon/named-icons/ExitIcon').then((module) => ({
            default: module.ExitIcon,
        })),
	expandVertical: () =>
        import('../../components/icon/named-icons/ExpandVerticalIcon').then((module) => ({
            default: module.ExpandVerticalIcon,
        })),
	externalLink: () =>
        import('../../components/icon/named-icons/ExternalLinkIcon').then((module) => ({
            default: module.ExternalLinkIcon,
        })),
	eyeClosed: () =>
        import('../../components/icon/named-icons/EyeClosedIcon').then((module) => ({
            default: module.EyeClosedIcon,
        })),
	eyeOpen: () =>
        import('../../components/icon/named-icons/EyeOpenIcon').then((module) => ({
            default: module.EyeOpenIcon,
        })),
	familyAid: () =>
        import('../../components/icon/named-icons/FamilyAidIcon').then((module) => ({
            default: module.FamilyAidIcon,
        })),
	file: () =>
        import('../../components/icon/named-icons/FileIcon').then((module) => ({
            default: module.FileIcon,
        })),
	fileMagnifyingGlass: () =>
        import('../../components/icon/named-icons/FileMagnifyingGlassIcon').then((module) => ({
            default: module.FileMagnifyingGlassIcon,
        })),
	filePencil: () =>
        import('../../components/icon/named-icons/FilePencilIcon').then((module) => ({
            default: module.FilePencilIcon,
        })),
	filter: () =>
        import('../../components/icon/named-icons/FilterIcon').then((module) => ({
            default: module.FilterIcon,
        })),
	fire: () =>
        import('../../components/icon/named-icons/FireIcon').then((module) => ({
            default: module.FireIcon,
        })),
	flag: () =>
        import('../../components/icon/named-icons/FlagIcon').then((module) => ({
            default: module.FlagIcon,
        })),
	flagCheckered: () =>
        import('../../components/icon/named-icons/FlagCheckeredIcon').then((module) => ({
            default: module.FlagCheckeredIcon,
        })),
	flagTriangle: () =>
        import('../../components/icon/named-icons/FlagTriangleIcon').then((module) => ({
            default: module.FlagTriangleIcon,
        })),
	flashlight: () =>
        import('../../components/icon/named-icons/FlashlightIcon').then((module) => ({
            default: module.FlashlightIcon,
        })),
	flashlightSlash: () =>
        import('../../components/icon/named-icons/FlashlightSlashIcon').then((module) => ({
            default: module.FlashlightSlashIcon,
        })),
	forbidden: () =>
        import('../../components/icon/named-icons/ForbiddenIcon').then((module) => ({
            default: module.ForbiddenIcon,
        })),
	ghost: () =>
        import('../../components/icon/named-icons/GhostIcon').then((module) => ({
            default: module.GhostIcon,
        })),
	gift: () =>
        import('../../components/icon/named-icons/GiftIcon').then((module) => ({
            default: module.GiftIcon,
        })),
	globe: () =>
        import('../../components/icon/named-icons/GlobeIcon').then((module) => ({
            default: module.GlobeIcon,
        })),
	grid: () =>
        import('../../components/icon/named-icons/GridIcon').then((module) => ({
            default: module.GridIcon,
        })),
	handArrowSwipe: () =>
        import('../../components/icon/named-icons/HandArrowSwipeIcon').then((module) => ({
            default: module.HandArrowSwipeIcon,
        })),
	handCross: () =>
        import('../../components/icon/named-icons/HandCrossIcon').then((module) => ({
            default: module.HandCrossIcon,
        })),
	handDigits: () =>
        import('../../components/icon/named-icons/HandDigitsIcon').then((module) => ({
            default: module.HandDigitsIcon,
        })),
	handHeart: () =>
        import('../../components/icon/named-icons/HandHeartIcon').then((module) => ({
            default: module.HandHeartIcon,
        })),
	hash: () =>
        import('../../components/icon/named-icons/HashIcon').then((module) => ({
            default: module.HashIcon,
        })),
	headset: () =>
        import('../../components/icon/named-icons/HeadsetIcon').then((module) => ({
            default: module.HeadsetIcon,
        })),
	heart: () =>
        import('../../components/icon/named-icons/HeartIcon').then((module) => ({
            default: module.HeartIcon,
        })),
	house: () =>
        import('../../components/icon/named-icons/HouseIcon').then((module) => ({
            default: module.HouseIcon,
        })),
	hurricane: () =>
        import('../../components/icon/named-icons/HurricaneIcon').then((module) => ({
            default: module.HurricaneIcon,
        })),
	image: () =>
        import('../../components/icon/named-icons/ImageIcon').then((module) => ({
            default: module.ImageIcon,
        })),
	infoCircle: () =>
        import('../../components/icon/named-icons/InfoCircleIcon').then((module) => ({
            default: module.InfoCircleIcon,
        })),
	languages: () =>
        import('../../components/icon/named-icons/LanguagesIcon').then((module) => ({
            default: module.LanguagesIcon,
        })),
	layers: () =>
        import('../../components/icon/named-icons/LayersIcon').then((module) => ({
            default: module.LayersIcon,
        })),
	leaf: () =>
        import('../../components/icon/named-icons/LeafIcon').then((module) => ({
            default: module.LeafIcon,
        })),
	lightbulb: () =>
        import('../../components/icon/named-icons/LightbulbIcon').then((module) => ({
            default: module.LightbulbIcon,
        })),
	lightning: () =>
        import('../../components/icon/named-icons/LightningIcon').then((module) => ({
            default: module.LightningIcon,
        })),
	list: () =>
        import('../../components/icon/named-icons/ListIcon').then((module) => ({
            default: module.ListIcon,
        })),
	locationArrow: () =>
        import('../../components/icon/named-icons/LocationArrowIcon').then((module) => ({
            default: module.LocationArrowIcon,
        })),
	locationGps: () =>
        import('../../components/icon/named-icons/LocationGpsIcon').then((module) => ({
            default: module.LocationGpsIcon,
        })),
	locationMarker: () =>
        import('../../components/icon/named-icons/LocationMarkerIcon').then((module) => ({
            default: module.LocationMarkerIcon,
        })),
	locationPin: () =>
        import('../../components/icon/named-icons/LocationPinIcon').then((module) => ({
            default: module.LocationPinIcon,
        })),
	locationZone: () =>
        import('../../components/icon/named-icons/LocationZoneIcon').then((module) => ({
            default: module.LocationZoneIcon,
        })),
	locationZoneSlash: () =>
        import('../../components/icon/named-icons/LocationZoneSlashIcon').then((module) => ({
            default: module.LocationZoneSlashIcon,
        })),
	lockArrowBack: () =>
        import('../../components/icon/named-icons/LockArrowBackIcon').then((module) => ({
            default: module.LockArrowBackIcon,
        })),
	lockClosed: () =>
        import('../../components/icon/named-icons/LockClosedIcon').then((module) => ({
            default: module.LockClosedIcon,
        })),
	lockOpen: () =>
        import('../../components/icon/named-icons/LockOpenIcon').then((module) => ({
            default: module.LockOpenIcon,
        })),
	logoGlovo: () =>
        import('../../components/icon/named-icons/LogoGlovoIcon').then((module) => ({
            default: module.LogoGlovoIcon,
        })),
	logoPrime: () =>
        import('../../components/icon/named-icons/LogoPrimeIcon').then((module) => ({
            default: module.LogoPrimeIcon,
        })),
	loop: () =>
        import('../../components/icon/named-icons/LoopIcon').then((module) => ({
            default: module.LoopIcon,
        })),
	magnifyingGlass: () =>
        import('../../components/icon/named-icons/MagnifyingGlassIcon').then((module) => ({
            default: module.MagnifyingGlassIcon,
        })),
	map: () =>
        import('../../components/icon/named-icons/MapIcon').then((module) => ({
            default: module.MapIcon,
        })),
	medal: () =>
        import('../../components/icon/named-icons/MedalIcon').then((module) => ({
            default: module.MedalIcon,
        })),
	megaphone: () =>
        import('../../components/icon/named-icons/MegaphoneIcon').then((module) => ({
            default: module.MegaphoneIcon,
        })),
	menu: () =>
        import('../../components/icon/named-icons/MenuIcon').then((module) => ({
            default: module.MenuIcon,
        })),
	milkCarton: () =>
        import('../../components/icon/named-icons/MilkCartonIcon').then((module) => ({
            default: module.MilkCartonIcon,
        })),
	milkCartonSlash: () =>
        import('../../components/icon/named-icons/MilkCartonSlashIcon').then((module) => ({
            default: module.MilkCartonSlashIcon,
        })),
	minus: () =>
        import('../../components/icon/named-icons/MinusIcon').then((module) => ({
            default: module.MinusIcon,
        })),
	mobile: () =>
        import('../../components/icon/named-icons/MobileIcon').then((module) => ({
            default: module.MobileIcon,
        })),
	mobileAlert: () =>
        import('../../components/icon/named-icons/MobileAlertIcon').then((module) => ({
            default: module.MobileAlertIcon,
        })),
	mobileCard: () =>
        import('../../components/icon/named-icons/MobileCardIcon').then((module) => ({
            default: module.MobileCardIcon,
        })),
	mobileCash: () =>
        import('../../components/icon/named-icons/MobileCashIcon').then((module) => ({
            default: module.MobileCashIcon,
        })),
	monitor: () =>
        import('../../components/icon/named-icons/MonitorIcon').then((module) => ({
            default: module.MonitorIcon,
        })),
	moon: () =>
        import('../../components/icon/named-icons/MoonIcon').then((module) => ({
            default: module.MoonIcon,
        })),
	motorcycle: () =>
        import('../../components/icon/named-icons/MotorcycleIcon').then((module) => ({
            default: module.MotorcycleIcon,
        })),
	over18Circle: () =>
        import('../../components/icon/named-icons/Over18CircleIcon').then((module) => ({
            default: module.Over18CircleIcon,
        })),
	over21Circle: () =>
        import('../../components/icon/named-icons/Over21CircleIcon').then((module) => ({
            default: module.Over21CircleIcon,
        })),
	package: () =>
        import('../../components/icon/named-icons/PackageIcon').then((module) => ({
            default: module.PackageIcon,
        })),
	partyPopper: () =>
        import('../../components/icon/named-icons/PartyPopperIcon').then((module) => ({
            default: module.PartyPopperIcon,
        })),
	paste: () =>
        import('../../components/icon/named-icons/PasteIcon').then((module) => ({
            default: module.PasteIcon,
        })),
	pencil: () =>
        import('../../components/icon/named-icons/PencilIcon').then((module) => ({
            default: module.PencilIcon,
        })),
	people: () =>
        import('../../components/icon/named-icons/PeopleIcon').then((module) => ({
            default: module.PeopleIcon,
        })),
	person: () =>
        import('../../components/icon/named-icons/PersonIcon').then((module) => ({
            default: module.PersonIcon,
        })),
	personFrame: () =>
        import('../../components/icon/named-icons/PersonFrameIcon').then((module) => ({
            default: module.PersonFrameIcon,
        })),
	personPlus: () =>
        import('../../components/icon/named-icons/PersonPlusIcon').then((module) => ({
            default: module.PersonPlusIcon,
        })),
	personRider: () =>
        import('../../components/icon/named-icons/PersonRiderIcon').then((module) => ({
            default: module.PersonRiderIcon,
        })),
	personTongue: () =>
        import('../../components/icon/named-icons/PersonTongueIcon').then((module) => ({
            default: module.PersonTongueIcon,
        })),
	personWalking: () =>
        import('../../components/icon/named-icons/PersonWalkingIcon').then((module) => ({
            default: module.PersonWalkingIcon,
        })),
	phone: () =>
        import('../../components/icon/named-icons/PhoneIcon').then((module) => ({
            default: module.PhoneIcon,
        })),
	phoneSlash: () =>
        import('../../components/icon/named-icons/PhoneSlashIcon').then((module) => ({
            default: module.PhoneSlashIcon,
        })),
	phoneSos: () =>
        import('../../components/icon/named-icons/PhoneSosIcon').then((module) => ({
            default: module.PhoneSosIcon,
        })),
	plus: () =>
        import('../../components/icon/named-icons/PlusIcon').then((module) => ({
            default: module.PlusIcon,
        })),
	plusCircle: () =>
        import('../../components/icon/named-icons/PlusCircleIcon').then((module) => ({
            default: module.PlusCircleIcon,
        })),
	qrCode: () =>
        import('../../components/icon/named-icons/QrCodeIcon').then((module) => ({
            default: module.QrCodeIcon,
        })),
	questionCircle: () =>
        import('../../components/icon/named-icons/QuestionCircleIcon').then((module) => ({
            default: module.QuestionCircleIcon,
        })),
	receipt: () =>
        import('../../components/icon/named-icons/ReceiptIcon').then((module) => ({
            default: module.ReceiptIcon,
        })),
	redo: () =>
        import('../../components/icon/named-icons/RedoIcon').then((module) => ({
            default: module.RedoIcon,
        })),
	rocket: () =>
        import('../../components/icon/named-icons/RocketIcon').then((module) => ({
            default: module.RocketIcon,
        })),
	scales: () =>
        import('../../components/icon/named-icons/ScalesIcon').then((module) => ({
            default: module.ScalesIcon,
        })),
	schoolBag: () =>
        import('../../components/icon/named-icons/SchoolBagIcon').then((module) => ({
            default: module.SchoolBagIcon,
        })),
	server: () =>
        import('../../components/icon/named-icons/ServerIcon').then((module) => ({
            default: module.ServerIcon,
        })),
	shareAndroid: () =>
        import('../../components/icon/named-icons/ShareAndroidIcon').then((module) => ({
            default: module.ShareAndroidIcon,
        })),
	shareIos: () =>
        import('../../components/icon/named-icons/ShareIosIcon').then((module) => ({
            default: module.ShareIosIcon,
        })),
	shield: () =>
        import('../../components/icon/named-icons/ShieldIcon').then((module) => ({
            default: module.ShieldIcon,
        })),
	shop: () =>
        import('../../components/icon/named-icons/ShopIcon').then((module) => ({
            default: module.ShopIcon,
        })),
	shoppingCart: () =>
        import('../../components/icon/named-icons/ShoppingCartIcon').then((module) => ({
            default: module.ShoppingCartIcon,
        })),
	signature: () =>
        import('../../components/icon/named-icons/SignatureIcon').then((module) => ({
            default: module.SignatureIcon,
        })),
	sliders: () =>
        import('../../components/icon/named-icons/SlidersIcon').then((module) => ({
            default: module.SlidersIcon,
        })),
	snail: () =>
        import('../../components/icon/named-icons/SnailIcon').then((module) => ({
            default: module.SnailIcon,
        })),
	snowflake: () =>
        import('../../components/icon/named-icons/SnowflakeIcon').then((module) => ({
            default: module.SnowflakeIcon,
        })),
	sound: () =>
        import('../../components/icon/named-icons/SoundIcon').then((module) => ({
            default: module.SoundIcon,
        })),
	soundSlash: () =>
        import('../../components/icon/named-icons/SoundSlashIcon').then((module) => ({
            default: module.SoundSlashIcon,
        })),
	sparkle: () =>
        import('../../components/icon/named-icons/SparkleIcon').then((module) => ({
            default: module.SparkleIcon,
        })),
	star: () =>
        import('../../components/icon/named-icons/StarIcon').then((module) => ({
            default: module.StarIcon,
        })),
	stopWatch: () =>
        import('../../components/icon/named-icons/StopWatchIcon').then((module) => ({
            default: module.StopWatchIcon,
        })),
	storeSign: () =>
        import('../../components/icon/named-icons/StoreSignIcon').then((module) => ({
            default: module.StoreSignIcon,
        })),
	storeSignCheck: () =>
        import('../../components/icon/named-icons/StoreSignCheckIcon').then((module) => ({
            default: module.StoreSignCheckIcon,
        })),
	storeSignCross: () =>
        import('../../components/icon/named-icons/StoreSignCrossIcon').then((module) => ({
            default: module.StoreSignCrossIcon,
        })),
	sun: () =>
        import('../../components/icon/named-icons/SunIcon').then((module) => ({
            default: module.SunIcon,
        })),
	tachometer: () =>
        import('../../components/icon/named-icons/TachometerIcon').then((module) => ({
            default: module.TachometerIcon,
        })),
	tag: () =>
        import('../../components/icon/named-icons/TagIcon').then((module) => ({
            default: module.TagIcon,
        })),
	tagDiscount: () =>
        import('../../components/icon/named-icons/TagDiscountIcon').then((module) => ({
            default: module.TagDiscountIcon,
        })),
	text: () =>
        import('../../components/icon/named-icons/TextIcon').then((module) => ({
            default: module.TextIcon,
        })),
	thermometerHot: () =>
        import('../../components/icon/named-icons/ThermometerHotIcon').then((module) => ({
            default: module.ThermometerHotIcon,
        })),
	thermometerLow: () =>
        import('../../components/icon/named-icons/ThermometerLowIcon').then((module) => ({
            default: module.ThermometerLowIcon,
        })),
	thermometerMedium: () =>
        import('../../components/icon/named-icons/ThermometerMediumIcon').then((module) => ({
            default: module.ThermometerMediumIcon,
        })),
	thermometerZero: () =>
        import('../../components/icon/named-icons/ThermometerZeroIcon').then((module) => ({
            default: module.ThermometerZeroIcon,
        })),
	thumbDown: () =>
        import('../../components/icon/named-icons/ThumbDownIcon').then((module) => ({
            default: module.ThumbDownIcon,
        })),
	thumbUp: () =>
        import('../../components/icon/named-icons/ThumbUpIcon').then((module) => ({
            default: module.ThumbUpIcon,
        })),
	timeline: () =>
        import('../../components/icon/named-icons/TimelineIcon').then((module) => ({
            default: module.TimelineIcon,
        })),
	timelineClock: () =>
        import('../../components/icon/named-icons/TimelineClockIcon').then((module) => ({
            default: module.TimelineClockIcon,
        })),
	trash: () =>
        import('../../components/icon/named-icons/TrashIcon').then((module) => ({
            default: module.TrashIcon,
        })),
	undo: () =>
        import('../../components/icon/named-icons/UndoIcon').then((module) => ({
            default: module.UndoIcon,
        })),
	undoCash: () =>
        import('../../components/icon/named-icons/UndoCashIcon').then((module) => ({
            default: module.UndoCashIcon,
        })),
	undoCross: () =>
        import('../../components/icon/named-icons/UndoCrossIcon').then((module) => ({
            default: module.UndoCrossIcon,
        })),
	upload: () =>
        import('../../components/icon/named-icons/UploadIcon').then((module) => ({
            default: module.UploadIcon,
        })),
	wallet: () =>
        import('../../components/icon/named-icons/WalletIcon').then((module) => ({
            default: module.WalletIcon,
        })),
	walletCoins: () =>
        import('../../components/icon/named-icons/WalletCoinsIcon').then((module) => ({
            default: module.WalletCoinsIcon,
        })),
	wand: () =>
        import('../../components/icon/named-icons/WandIcon').then((module) => ({
            default: module.WandIcon,
        })),
	wheat: () =>
        import('../../components/icon/named-icons/WheatIcon').then((module) => ({
            default: module.WheatIcon,
        })),
	wheatSlash: () =>
        import('../../components/icon/named-icons/WheatSlashIcon').then((module) => ({
            default: module.WheatSlashIcon,
        })),
	wifi: () =>
        import('../../components/icon/named-icons/WifiIcon').then((module) => ({
            default: module.WifiIcon,
        })),
	wifiSlash: () =>
        import('../../components/icon/named-icons/WifiSlashIcon').then((module) => ({
            default: module.WifiSlashIcon,
        })),
}

export const NamedIconComponentsMap: Record<IconNames, NamedIconComponentType> = {
	addressBook: NamedIcons.AddressBookIcon,
	alarmClock: NamedIcons.AlarmClockIcon,
	allergy: NamedIcons.AllergyIcon,
	arrowBackward: NamedIcons.ArrowBackwardIcon,
	arrowDown: NamedIcons.ArrowDownIcon,
	arrowDowntrend: NamedIcons.ArrowDowntrendIcon,
	arrowForward: NamedIcons.ArrowForwardIcon,
	arrowTrack: NamedIcons.ArrowTrackIcon,
	arrowUp: NamedIcons.ArrowUpIcon,
	arrowUptrend: NamedIcons.ArrowUptrendIcon,
	arrowUptrendSquare: NamedIcons.ArrowUptrendSquareIcon,
	arrowsBackwardForward: NamedIcons.ArrowsBackwardForwardIcon,
	arrowsCollapse: NamedIcons.ArrowsCollapseIcon,
	arrowsExpand: NamedIcons.ArrowsExpandIcon,
	arrowsUpDown: NamedIcons.ArrowsUpDownIcon,
	backspace: NamedIcons.BackspaceIcon,
	badge: NamedIcons.BadgeIcon,
	badgeEqual: NamedIcons.BadgeEqualIcon,
	bag: NamedIcons.BagIcon,
	bagCheck: NamedIcons.BagCheckIcon,
	bagCross: NamedIcons.BagCrossIcon,
	bagGlovo: NamedIcons.BagGlovoIcon,
	bagHappy: NamedIcons.BagHappyIcon,
	bagInfo: NamedIcons.BagInfoIcon,
	bags: NamedIcons.BagsIcon,
	bars: NamedIcons.BarsIcon,
	batteryCharging: NamedIcons.BatteryChargingIcon,
	batteryFull: NamedIcons.BatteryFullIcon,
	batteryHalf: NamedIcons.BatteryHalfIcon,
	batteryLow: NamedIcons.BatteryLowIcon,
	batterySlash: NamedIcons.BatterySlashIcon,
	bell: NamedIcons.BellIcon,
	bench: NamedIcons.BenchIcon,
	bicycle: NamedIcons.BicycleIcon,
	binoculars: NamedIcons.BinocularsIcon,
	bookmark: NamedIcons.BookmarkIcon,
	bug: NamedIcons.BugIcon,
	buildings: NamedIcons.BuildingsIcon,
	burgerSize: NamedIcons.BurgerSizeIcon,
	cake: NamedIcons.CakeIcon,
	calendar: NamedIcons.CalendarIcon,
	camera: NamedIcons.CameraIcon,
	car: NamedIcons.CarIcon,
	card: NamedIcons.CardIcon,
	cardArrowDown: NamedIcons.CardArrowDownIcon,
	cardArrowUp: NamedIcons.CardArrowUpIcon,
	cardGlovo: NamedIcons.CardGlovoIcon,
	cardMagnifyingGlass: NamedIcons.CardMagnifyingGlassIcon,
	cardPin: NamedIcons.CardPinIcon,
	cards: NamedIcons.CardsIcon,
	caretBackward: NamedIcons.CaretBackwardIcon,
	caretDown: NamedIcons.CaretDownIcon,
	caretForward: NamedIcons.CaretForwardIcon,
	caretUp: NamedIcons.CaretUpIcon,
	carrot: NamedIcons.CarrotIcon,
	cash: NamedIcons.CashIcon,
	cashArrowDown: NamedIcons.CashArrowDownIcon,
	cashArrowUp: NamedIcons.CashArrowUpIcon,
	chartBars: NamedIcons.ChartBarsIcon,
	chartBarsCircle: NamedIcons.ChartBarsCircleIcon,
	chartPie: NamedIcons.ChartPieIcon,
	chat: NamedIcons.ChatIcon,
	chatBubbles: NamedIcons.ChatBubblesIcon,
	chatBubblesQuestion: NamedIcons.ChatBubblesQuestionIcon,
	chatCross: NamedIcons.ChatCrossIcon,
	chatPhone: NamedIcons.ChatPhoneIcon,
	chatQuestion: NamedIcons.ChatQuestionIcon,
	check: NamedIcons.CheckIcon,
	checkCircle: NamedIcons.CheckCircleIcon,
	chevronBackward: NamedIcons.ChevronBackwardIcon,
	chevronDown: NamedIcons.ChevronDownIcon,
	chevronForward: NamedIcons.ChevronForwardIcon,
	chevronForwardDouble: NamedIcons.ChevronForwardDoubleIcon,
	chevronUp: NamedIcons.ChevronUpIcon,
	circle: NamedIcons.CircleIcon,
	circlesConcentric: NamedIcons.CirclesConcentricIcon,
	clip: NamedIcons.ClipIcon,
	clock: NamedIcons.ClockIcon,
	clockBack: NamedIcons.ClockBackIcon,
	cloudRain: NamedIcons.CloudRainIcon,
	cloudSnow: NamedIcons.CloudSnowIcon,
	cog: NamedIcons.CogIcon,
	coinArrowUp: NamedIcons.CoinArrowUpIcon,
	collapseVertical: NamedIcons.CollapseVerticalIcon,
	companyBuilding: NamedIcons.CompanyBuildingIcon,
	compass: NamedIcons.CompassIcon,
	copy: NamedIcons.CopyIcon,
	cross: NamedIcons.CrossIcon,
	crossCircle: NamedIcons.CrossCircleIcon,
	crown: NamedIcons.CrownIcon,
	cutlery: NamedIcons.CutleryIcon,
	cutlerySlash: NamedIcons.CutlerySlashIcon,
	deskBell: NamedIcons.DeskBellIcon,
	diamond: NamedIcons.DiamondIcon,
	directions: NamedIcons.DirectionsIcon,
	discount: NamedIcons.DiscountIcon,
	download: NamedIcons.DownloadIcon,
	drop: NamedIcons.DropIcon,
	edit: NamedIcons.EditIcon,
	eggBroken: NamedIcons.EggBrokenIcon,
	eggQuestion: NamedIcons.EggQuestionIcon,
	ellipsisHorizontal: NamedIcons.EllipsisHorizontalIcon,
	ellipsisVertical: NamedIcons.EllipsisVerticalIcon,
	enter: NamedIcons.EnterIcon,
	envelope: NamedIcons.EnvelopeIcon,
	exclamationCircle: NamedIcons.ExclamationCircleIcon,
	exclamationTriangle: NamedIcons.ExclamationTriangleIcon,
	exit: NamedIcons.ExitIcon,
	expandVertical: NamedIcons.ExpandVerticalIcon,
	externalLink: NamedIcons.ExternalLinkIcon,
	eyeClosed: NamedIcons.EyeClosedIcon,
	eyeOpen: NamedIcons.EyeOpenIcon,
	familyAid: NamedIcons.FamilyAidIcon,
	file: NamedIcons.FileIcon,
	fileMagnifyingGlass: NamedIcons.FileMagnifyingGlassIcon,
	filePencil: NamedIcons.FilePencilIcon,
	filter: NamedIcons.FilterIcon,
	fire: NamedIcons.FireIcon,
	flag: NamedIcons.FlagIcon,
	flagCheckered: NamedIcons.FlagCheckeredIcon,
	flagTriangle: NamedIcons.FlagTriangleIcon,
	flashlight: NamedIcons.FlashlightIcon,
	flashlightSlash: NamedIcons.FlashlightSlashIcon,
	forbidden: NamedIcons.ForbiddenIcon,
	ghost: NamedIcons.GhostIcon,
	gift: NamedIcons.GiftIcon,
	globe: NamedIcons.GlobeIcon,
	grid: NamedIcons.GridIcon,
	handArrowSwipe: NamedIcons.HandArrowSwipeIcon,
	handCross: NamedIcons.HandCrossIcon,
	handDigits: NamedIcons.HandDigitsIcon,
	handHeart: NamedIcons.HandHeartIcon,
	hash: NamedIcons.HashIcon,
	headset: NamedIcons.HeadsetIcon,
	heart: NamedIcons.HeartIcon,
	house: NamedIcons.HouseIcon,
	hurricane: NamedIcons.HurricaneIcon,
	image: NamedIcons.ImageIcon,
	infoCircle: NamedIcons.InfoCircleIcon,
	languages: NamedIcons.LanguagesIcon,
	layers: NamedIcons.LayersIcon,
	leaf: NamedIcons.LeafIcon,
	lightbulb: NamedIcons.LightbulbIcon,
	lightning: NamedIcons.LightningIcon,
	list: NamedIcons.ListIcon,
	locationArrow: NamedIcons.LocationArrowIcon,
	locationGps: NamedIcons.LocationGpsIcon,
	locationMarker: NamedIcons.LocationMarkerIcon,
	locationPin: NamedIcons.LocationPinIcon,
	locationZone: NamedIcons.LocationZoneIcon,
	locationZoneSlash: NamedIcons.LocationZoneSlashIcon,
	lockArrowBack: NamedIcons.LockArrowBackIcon,
	lockClosed: NamedIcons.LockClosedIcon,
	lockOpen: NamedIcons.LockOpenIcon,
	logoGlovo: NamedIcons.LogoGlovoIcon,
	logoPrime: NamedIcons.LogoPrimeIcon,
	loop: NamedIcons.LoopIcon,
	magnifyingGlass: NamedIcons.MagnifyingGlassIcon,
	map: NamedIcons.MapIcon,
	medal: NamedIcons.MedalIcon,
	megaphone: NamedIcons.MegaphoneIcon,
	menu: NamedIcons.MenuIcon,
	milkCarton: NamedIcons.MilkCartonIcon,
	milkCartonSlash: NamedIcons.MilkCartonSlashIcon,
	minus: NamedIcons.MinusIcon,
	mobile: NamedIcons.MobileIcon,
	mobileAlert: NamedIcons.MobileAlertIcon,
	mobileCard: NamedIcons.MobileCardIcon,
	mobileCash: NamedIcons.MobileCashIcon,
	monitor: NamedIcons.MonitorIcon,
	moon: NamedIcons.MoonIcon,
	motorcycle: NamedIcons.MotorcycleIcon,
	over18Circle: NamedIcons.Over18CircleIcon,
	over21Circle: NamedIcons.Over21CircleIcon,
	package: NamedIcons.PackageIcon,
	partyPopper: NamedIcons.PartyPopperIcon,
	paste: NamedIcons.PasteIcon,
	pencil: NamedIcons.PencilIcon,
	people: NamedIcons.PeopleIcon,
	person: NamedIcons.PersonIcon,
	personFrame: NamedIcons.PersonFrameIcon,
	personPlus: NamedIcons.PersonPlusIcon,
	personRider: NamedIcons.PersonRiderIcon,
	personTongue: NamedIcons.PersonTongueIcon,
	personWalking: NamedIcons.PersonWalkingIcon,
	phone: NamedIcons.PhoneIcon,
	phoneSlash: NamedIcons.PhoneSlashIcon,
	phoneSos: NamedIcons.PhoneSosIcon,
	plus: NamedIcons.PlusIcon,
	plusCircle: NamedIcons.PlusCircleIcon,
	qrCode: NamedIcons.QrCodeIcon,
	questionCircle: NamedIcons.QuestionCircleIcon,
	receipt: NamedIcons.ReceiptIcon,
	redo: NamedIcons.RedoIcon,
	rocket: NamedIcons.RocketIcon,
	scales: NamedIcons.ScalesIcon,
	schoolBag: NamedIcons.SchoolBagIcon,
	server: NamedIcons.ServerIcon,
	shareAndroid: NamedIcons.ShareAndroidIcon,
	shareIos: NamedIcons.ShareIosIcon,
	shield: NamedIcons.ShieldIcon,
	shop: NamedIcons.ShopIcon,
	shoppingCart: NamedIcons.ShoppingCartIcon,
	signature: NamedIcons.SignatureIcon,
	sliders: NamedIcons.SlidersIcon,
	snail: NamedIcons.SnailIcon,
	snowflake: NamedIcons.SnowflakeIcon,
	sound: NamedIcons.SoundIcon,
	soundSlash: NamedIcons.SoundSlashIcon,
	sparkle: NamedIcons.SparkleIcon,
	star: NamedIcons.StarIcon,
	stopWatch: NamedIcons.StopWatchIcon,
	storeSign: NamedIcons.StoreSignIcon,
	storeSignCheck: NamedIcons.StoreSignCheckIcon,
	storeSignCross: NamedIcons.StoreSignCrossIcon,
	sun: NamedIcons.SunIcon,
	tachometer: NamedIcons.TachometerIcon,
	tag: NamedIcons.TagIcon,
	tagDiscount: NamedIcons.TagDiscountIcon,
	text: NamedIcons.TextIcon,
	thermometerHot: NamedIcons.ThermometerHotIcon,
	thermometerLow: NamedIcons.ThermometerLowIcon,
	thermometerMedium: NamedIcons.ThermometerMediumIcon,
	thermometerZero: NamedIcons.ThermometerZeroIcon,
	thumbDown: NamedIcons.ThumbDownIcon,
	thumbUp: NamedIcons.ThumbUpIcon,
	timeline: NamedIcons.TimelineIcon,
	timelineClock: NamedIcons.TimelineClockIcon,
	trash: NamedIcons.TrashIcon,
	undo: NamedIcons.UndoIcon,
	undoCash: NamedIcons.UndoCashIcon,
	undoCross: NamedIcons.UndoCrossIcon,
	upload: NamedIcons.UploadIcon,
	wallet: NamedIcons.WalletIcon,
	walletCoins: NamedIcons.WalletCoinsIcon,
	wand: NamedIcons.WandIcon,
	wheat: NamedIcons.WheatIcon,
	wheatSlash: NamedIcons.WheatSlashIcon,
	wifi: NamedIcons.WifiIcon,
	wifiSlash: NamedIcons.WifiSlashIcon,
}
